
import VuePicker from 'vue-pickers'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getDisplayName, getuserCurrentApp } from '@/utils/cookies.ts'
import { AppModule, DeviceType } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import { LIVEISSUESAPI } from '@/api/live'
import { CONFIGAPI } from '@/api/config'
import { ConfigModule } from '@/store/modules/config'
import IssueType from '@/views/config/issueType/index.vue'

@Component({
  components: {
    VuePicker
  }
})
export default class AppMain extends Vue {
  @Prop({ default: false }) private editForm!: any // 编辑表单时用到的表单数据
  private editId = 0
  private isDisableSubmit = false // 避免重复触发提交按钮
  private locationOptions = [] // 所在地区options
  private issueTypeOptions = [] // 问题类型options
  // 联动下拉框手机端
  private pickerIssueVisible = false // 点击所在地区文本框，显示picker联动
  private defaultIssueIndex = [] as number[] // 默认联动定位，从0开始，0代表第一行
  private liveIssueCn = '' // 移动端：所在地区内容

  private isShowPosition = true // 是否显示房间号输入

  private response_minutes = 0 // 受理时长
  private resolve_minutes = 0 // 完成时长

  formData = {
    // tutorName: this.username,
    // issueDate: new Date(),
    is_live_influenced: 1,
    location: [] as any,
    position: '',
    describe: '',
    creator: '',
    creator_cn: '',
    accept_user_cn: this.username,
    accept_user: this.userWorkCode,
    create_time: '',
    accept_time: '',
    finish_time: '',
    is_official: 0,
    belong_to_dept: '1',
    solution: '',
    issue_type: [] as any,
    is_solved: 1,
    solution_type: { solution_type_key: '0-1' }
  }

  formRules: object = {
    creator: [{ required: true, message: '请输入主讲老师名称', trigger: ['blur', 'change'] }],
    accept_user_cn: [{ required: true }],
    // issueDate: [{ required: true }],
    is_live_influenced: [{ required: true, message: '请选择是否为正价课', trigger: 'change' }],
    location: [{ required: true, message: '请选择所在地区', trigger: 'change' }],
    position: [{ required: true, message: '请填写直播间号', trigger: 'blur' }],
    describe: [{ required: true, message: '请简单描述遇到的问题', trigger: 'blur' }],
    create_time: [{ required: true, message: '请选择日期', trigger: 'change' }],
    accept_time: [{ required: true, message: '请选择日期', trigger: 'change' }],
    finish_time: [{ required: true, message: '请选择日期', trigger: 'change' }],
    is_official: [{ required: true, message: '请选择是否为正价课', trigger: 'change' }],
    belong_to_dept: [{ required: true, message: '请选择是否归属直播保障', trigger: 'change' }],
    solution: [{ required: true, message: '请输入问题解决方案', trigger: 'change' }],
    issue_type: [{ required: true, message: '请选择问题类型' }],
    is_solved: [{ required: true, message: '请选择问题是否解决' }],
    solution_type: [{ required: true, message: '请选择解决方式', trigger: 'change' }]
  }

  pickerOptions: object = {
    disabledDate(time: any) {
      return time.getTime() > Date.now()
    }
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get isEdit() {
    return !!this.editForm
  }

  // 标题
  get formTitle() {
    let title = '直播保障'
    title += this.isEdit ? '工单编辑' : '工单录入'
    return title
  }

  get device() {
    return AppModule.device
  }

  get classObj() {
    return {
      mobile: this.device === DeviceType.Mobile
    }
  }

  get username() {
    return getDisplayName()
  }

  get userWorkCode() {
    return UserModule.workcode
  }

  // 响应
  @Watch('formData.accept_time', { deep: true })
  private watchAccepTime(newVal: string, oldVal: string) {
    if (newVal === null) {
      this.response_minutes = 0
      this.resolve_minutes = 0
    }
    if (this.formData.accept_time && this.formData.create_time) {
      const response_time = new Date(this.formData.accept_time).getTime()
      const happend_time = new Date(this.formData.create_time).getTime()
      const minuteDiff = Math.trunc((response_time - happend_time) / 1000 / 60) // 分钟
      if (minuteDiff < 0) {
        this.$message({
          message: '问题响应时间需大于问题发生时间！',
          type: 'error'
        })
        this.response_minutes = 0
        return
      } else {
        this.response_minutes = minuteDiff
      }
    }
    if (this.formData.accept_time && this.formData.finish_time) {
      const resolve_time = new Date(this.formData.finish_time).getTime()
      const response_time = new Date(this.formData.accept_time).getTime()
      const minuteDiff = Math.trunc((resolve_time - response_time) / 1000 / 60) // 分钟
      if (minuteDiff < 0) {
        this.$message({
          message: '问题解决时间需大于问题响应时间！',
          type: 'error'
        })
        this.resolve_minutes = 0
      } else {
        this.resolve_minutes = minuteDiff
      }
    }
  }

  // 发生
  @Watch('formData.create_time', { deep: true })
  private watchCreateTime(newVal: string, oldVal: string) {
    if (newVal === null) {
      this.response_minutes = 0
    }
    if (this.formData.accept_time && this.formData.create_time) {
      const response_time_tmp = this.formData.accept_time.replace(/-/g, '/')
      const happend_time_tmp = this.formData.create_time.replace(/-/g, '/')
      const response_time = new Date(response_time_tmp).getTime()
      const happend_time = new Date(happend_time_tmp).getTime()
      const minuteDiff = Math.trunc((response_time - happend_time) / 1000 / 60) // 分钟
      if (minuteDiff < 0) {
        this.$message({
          message: '问题响应时间需大于问题发生时间！',
          type: 'error'
        })
        this.response_minutes = 0
      } else {
        this.response_minutes = minuteDiff
      }
    }
  }

  // 完成
  @Watch('formData.finish_time', { deep: true })
  private watchFinishTime(newVal: string, oldVal: string) {
    if (newVal === null) {
      this.resolve_minutes = 0
    }
    if (this.formData.finish_time && this.formData.accept_time) {
      const resolve_time_tmp = this.formData.finish_time.replace(/-/g, '/')
      const response_time_tmp = this.formData.accept_time.replace(/-/g, '/')
      const resolve_time = new Date(resolve_time_tmp).getTime()
      const response_time = new Date(response_time_tmp).getTime()
      const minuteDiff = Math.trunc((resolve_time - response_time) / 1000 / 60) // 分钟
      if (minuteDiff < 0) {
        this.$message({
          message: '问题解决时间需大于问题响应时间！',
          type: 'error'
        })
        this.resolve_minutes = 0
      } else {
        this.resolve_minutes = minuteDiff
      }
    }
  }

  @Watch('locationOptions')
  private watchLocationOptions(newVal: any, oldVal: any) {
    if (this.isEdit) {
      this.handleChangeLocation(this.formData.location)
    }
  }

  mounted() {
    this.getTutorIssueType() // 获取班主任所在地区列表
    this.getIssueType() // 获取问题类型
    // 编辑时location值设置
    if (this.isEdit) {
      this.assignFormdata()
      this.handleChangeLocation(this.formData.location)
    }
  }

  // 用户姓名/工号输入建议
  private querySearchUser(queryString: string, callback: any) {
    CONFIGAPI.getUsersData({
      key: queryString
    }).then((res) => {
      if (res.stat === 1) {
        callback(res.data)
      }
    }).catch((error) => {
      console.log('发生错误！', error)
    })
  }

  // 选中用户
  private handleSelectCreator(user: any) {
    (this.$refs.tutorForm as any).clearValidate('creator')

    this.formData.creator_cn = user.name
    this.formData.creator = user.workcode
  }

  private selectSolutionType(solution_type: any) {
    (this.$refs.tutorForm as any).clearValidate('solution_type')
    console.log(solution_type)
    this.formData.solution_type = solution_type.solution_type_key
  }

  /**
   * 选择问题类型同步更新 问题描述和解决方案
   * @param value
   */
  handleIssueTypeChange(value: any) {
    interface IssueType {
      id: number;
      label: string;
      describe: string;
      solution: string;
      switchValue: boolean;
      parent_id: number;
      children?: IssueType[];
    }

    // 根据选择的问题类型，自动填充问题描述和解决方案
    // 这里可以根据 value 来获取对应的问题描述和解决方案，然后赋值给 formData
    // 示例中直接赋值为空字符串，你需要替换为实际逻辑
    // 根据选择的问题类型，自动填充问题描述和解决方案
    // 遍历 issueTypeOptions 数组查找目标对象
    const issueTypeOptions: IssueType[] = this.issueTypeOptions
    for (const option of issueTypeOptions) {
      if (option.children) {
        // 如果存在 children 属性，则在 children 中查找目标对象
        const child = option.children.find(child => child.id === value[value.length - 1])
        if (child && child.switchValue) {
          this.formData.describe = child.describe || ''
          this.formData.solution = child.solution || ''
          break // 找到目标对象后结束循环
        } else {
          this.formData.describe = ''
          this.formData.solution = ''
        }
      }
    }
  }

  // 获取问题类型
  private async getIssueType() {
    const options = ConfigModule.issueTypeOptions
    if (options.length <= 0) { // 仅首次打开时请求
      const { data } = await CONFIGAPI.getIssuesType({ app_id: this.userCurrentApp })
      const newData: any = []
      // 删掉掉没有基地的地区
      data.map((item: any) => {
        if (item.children && item.children.length !== 0) {
          newData.push(item)
        }
      })
      this.issueTypeOptions = newData
      ConfigModule.setIssueTypeOptions(newData)
    } else {
      this.issueTypeOptions = options
    }
  }

  private formatDateTime(time: any) {
    const dateTime = new Date(time)
    const year = dateTime.getFullYear()
    const month = dateTime.getMonth() + 1
    const date = dateTime.getDate()
    const hour = dateTime.getHours()
    const minute = dateTime.getMinutes()
    return `${year}-${this.addZero(month)}-${this.addZero(date)} ${this.addZero(hour)}:${this.addZero(minute)}`
  }

  private addZero(v: any) {
    return v < 10 ? '0' + v : v
  }

  private handleChangeLocation(value: any) {
    const result = this.locationOptions.filter((item: any) => {
      return item.id === value[0] && item.label.indexOf('在家') === -1
    })
    this.isShowPosition = result.length > 0
    if (this.formData.position === '无') {
      this.formData.position = ''
    }
  }

  // 获取班主任所在地区列表
  private async getTutorIssueType() {
    const { data } = await CONFIGAPI.getLocation({ app_id: this.userCurrentApp })
    let newData: any = []
    // 删掉掉没有基地的地区
    data.map((item: any) => {
      if (item.children && item.children.length !== 0) {
        newData.push(item)
      }
    })
    if (this.classObj.mobile) { // 手机端插件数据结构需要用value
      newData = JSON.parse(JSON.stringify(newData).replace(/"id"/g, '"value"'))
    }
    this.locationOptions = newData
    // 移动端：编辑时定位直播间级联的默认位置
    if (this.classObj.mobile && this.isEdit) {
      this.locationOptions.some((parent: any, index1: number) => {
        if (parent.value === this.editForm.location.place_id) {
          parent.children.some((building: any, index2: number) => {
            if (building.value === this.editForm.location.building_id) {
              building.children.some((item: any, index3: number) => {
                if (item.value === this.editForm.location.floor_id) {
                  this.defaultIssueIndex = [index1, index2, index3]
                }
              })
            }
          })
        }
      })
    }
  }

  // 移动端：所在地区联动确认
  confirmChangeIssue(res: any) {
    const issueType: string[] = []
    res.map((item: { label: string }) => {
      issueType.push(item.label)
    })
    this.liveIssueCn = issueType.join('/')
    this.formData.location = [res[0].value || res[0].id, res[1].value || res[1].id, res[2] ? res[2].value || res[2].id : '']
  }

  // 编辑赋值
  assignFormdata() {
    this.editId = this.editForm.id
    const editLocationType: any = [this.editForm.location.place_id, this.editForm.location.building_id, this.editForm.location.floor_id]
    const editIssueType: any = [this.editForm.issue_type.pid, this.editForm.issue_type.id]
    this.formData = {
      is_live_influenced: this.editForm.is_live_influenced,
      location: editLocationType,
      position: this.editForm.position,
      describe: this.editForm.describe,
      creator: this.editForm.creator.workcode,
      creator_cn: this.editForm.creator.name,
      accept_user_cn: this.editForm.accept_user.name,
      accept_user: this.editForm.accept_user.workcode,
      create_time: this.editForm.create_time,
      accept_time: this.editForm.accept_time,
      finish_time: this.editForm.finish_time,
      is_official: Number(this.editForm.is_official),
      belong_to_dept: String(this.editForm.belong_to_dept),
      solution: this.editForm.solution || '',
      is_solved: this.editForm.status === 3 ? 1 : 0, // 状态 != 3均为未完成
      issue_type: editIssueType,
      solution_type: this.editForm.solution_type.solution_type_key
    }
    this.liveIssueCn = this.editForm.location.place + '/' + this.editForm.location.building + '/' + this.editForm.location.floor

    if (this.editForm.finish_time) {
      const accept_time = new Date(this.formData.accept_time).getTime()
      const finish_time = new Date(this.formData.finish_time).getTime()
      const minuteDiff = (finish_time - accept_time) / 1000 / 60 // 分钟
      this.resolve_minutes = Math.trunc(minuteDiff)
    }

    const create_time_tmp = this.formData.create_time.replace(/-/g, '/')
    const create_time = new Date(create_time_tmp).getTime()
    const accept_time_tmp = this.formData.accept_time.replace(/-/g, '/')
    const accept_time = new Date(accept_time_tmp).getTime()
    const minuteDiff = (accept_time - create_time) / 1000 / 60 // 分钟
    this.response_minutes = Math.trunc(minuteDiff)
  }

  handleSubmit(formName: string) {
    const resolve_time_tmp = this.formData.accept_time.replace(/-/g, '/')
    const response_time_tmp = this.formData.create_time.replace(/-/g, '/')
    if (new Date(resolve_time_tmp).getTime() - new Date(response_time_tmp).getTime() < 0) {
      this.$message({
        message: '问题响应时间需大于问题发生时间！',
        type: 'error'
      })
      return
    }
    if (this.formData.finish_time) {
      const finish_time_tmp = this.formData.finish_time.replace(/-/g, '/')
      if (new Date(finish_time_tmp).getTime() - new Date(resolve_time_tmp).getTime() < 0) {
        this.$message({
          message: '问题解决时间需大于问题响应时间！',
          type: 'error'
        })
        return
      }
    }

    if (!this.isShowPosition) {
      this.formData.position = '无'
    }

    if (!this.formData.is_solved) {
      this.formData.finish_time = ''
    }

    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true
        const action = 'manualAdd'
        await (LIVEISSUESAPI as any)[action]({
          location: Number(this.formData.location[2].split('_')[1]),
          describe: this.formData.describe,
          position: this.formData.position,
          is_live_influenced: this.formData.is_live_influenced,
          creator: this.formData.creator,
          creator_cn: this.formData.creator_cn,
          accept_user: this.formData.accept_user,
          accept_user_cn: this.formData.accept_user_cn,
          create_time: this.formData.create_time,
          accept_time: this.formData.accept_time,
          finish_time: this.formData.finish_time ? this.formData.finish_time : null,
          is_official: this.formData.is_official,
          is_living: this.formData.is_official,
          belong_to_dept: String(this.formData.belong_to_dept),
          issue_type: this.formData.issue_type[1],
          is_solved: this.formData.is_solved,
          solution: this.formData.solution,
          solution_type: this.formData.solution_type
        }, {
          app_id: this.userCurrentApp
        }).then((res: any) => {
          if (res.stat === 1) {
            this.$message.success('提交成功')
            this.handleResetForm(formName)
            this.$router.push({ path: '/home' })
          }
          this.isDisableSubmit = false
        }).catch(() => {
          this.isDisableSubmit = false
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleEditSubmit(formName: string) {
    const resolve_time_tmp = this.formData.accept_time.replace(/-/g, '/')
    const response_time_tmp = this.formData.create_time.replace(/-/g, '/')
    if (new Date(resolve_time_tmp).getTime() - new Date(response_time_tmp).getTime() < 0) {
      this.$message({
        message: '问题响应时间需大于问题发生时间！',
        type: 'error'
      })
      return
    }
    if (this.formData.finish_time) {
      const finish_time_tmp = this.formData.finish_time.replace(/-/g, '/')
      if (new Date(finish_time_tmp).getTime() - new Date(resolve_time_tmp).getTime() < 0) {
        this.$message({
          message: '问题解决时间需大于问题响应时间！',
          type: 'error'
        })
        return
      }
    }

    if (!this.isShowPosition) {
      this.formData.position = '无'
    }

    if (!this.formData.is_solved) {
      this.formData.finish_time = ''
    }

    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true
        const action = 'manualEdit'
        await (LIVEISSUESAPI as any)[action]({
          id: this.editId,
          location: Number(this.formData.location[2].split('_')[1]),
          describe: this.formData.describe,
          position: this.formData.position,
          is_live_influenced: this.formData.is_live_influenced,
          creator: this.formData.creator,
          creator_cn: this.formData.creator_cn,
          accept_user: this.formData.accept_user,
          accept_user_cn: this.formData.accept_user_cn,
          create_time: this.formData.create_time,
          accept_time: this.formData.accept_time,
          finish_time: this.formData.finish_time ? this.formData.finish_time : null,
          is_official: this.formData.is_official,
          is_living: this.formData.is_official,
          belong_to_dept: String(this.formData.belong_to_dept),
          issue_type: this.formData.issue_type[1],
          is_solved: this.formData.is_solved,
          solution: this.formData.solution,
          solution_type: this.formData.solution_type
        }, {
          app_id: this.userCurrentApp
        }).then((res: any) => {
          if (res.stat === 1) {
            this.$emit('handleSuccess', res)
            this.$emit('handleCloseDialog')
          }
          this.isDisableSubmit = false
        }).catch(() => {
          this.isDisableSubmit = false
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleResetForm(formName: string) {
    this.liveIssueCn = ''
    this.defaultIssueIndex = [0, 0, 0]
    const form: any = this.$refs[formName]
    form.resetFields()
    this.formData.location = [0, 0, 0]
  }
}
